// Earliest run per epic that has recorded participants. Tracking began on
// these dates; earlier runs aren't in our data. Dates are ET calendar dates
// (date only - no time of day).
export interface EpicFirstRecord {
  date: string; // YYYY-MM-DD
  time: string; // mm:ss
  players: string[];
}

export const EPIC_FIRST_RECORDS: Record<string, EpicFirstRecord> = {
  "Sea King's Dominion": {
    date: "2026-01-05",
    time: "08:01",
    players: ["Anssett", "Kanaye", "Madrox"]
  },
  "Titans' Keep": {
    date: "2026-01-05",
    time: "11:41",
    players: ["Anssett", "Blunt", "Kalsch", "Kanaye", "Madrox"]
  },
  "The Cracks of Terra": {
    date: "2026-01-11",
    time: "19:24",
    players: ["Bhengis", "Bloodthorn", "Kanaye", "Madrox", "Sindayne"]
  }
};

// "2026-01-05" -> "Jan 5, 2026". Built from the parts so no timezone shift
// can move the day.
export const formatFirstRecordDate = (isoDate: string): string => {
  const [year, month, day] = isoDate.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString("en-US", {
    timeZone: "UTC",
    month: "short",
    day: "numeric",
    year: "numeric"
  });
};
